export class AbstractTracker {
  register() {
    throw new Error("Method 'register()' must be implemented.");
  }
  setGroup() {
    throw new Error("Method 'setGroup()' must be implemented.");
  }
  setTenant() {
    throw new Error("Method 'setTenant()' must be implemented.");
  }
  setUserId() {
    throw new Error("Method 'setUserId()' must be implemented.");
  }
  setVersion() {
    throw new Error("Method 'setVersion()' must be implemented.");
  }
  track() {
    throw new Error("Method 'track()' must be implemented.");
  }
  trackPage() {
    throw new Error("Method 'trackPage()' must be implemented.");
  }
  reset() {
    throw new Error("Method 'reset()' must be implemented.");
  }
}
